export default "__VITE_ASSET__5f9ccf6e__"